import React, {useEffect, useMemo, useState} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {css} from "@panda/css";

import {display} from "@pg-design/helpers-css";
import {EditIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";
import {noop} from "@pg-mono/nodash";

import {useGetRegionDetailListQuery} from "../../../region/api/get_region_detail_list";
import {fetchAllSearchLists} from "../../../search/actions/fetch_search_all_action";
import {ISearchInputValue} from "../../../search/components/ISearchInputValue";
import {ISearchAutocompleteFormValues, SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {SearchAutocompleteDropdown} from "../../../search/components/search_autocomplete/SearchAutocompleteDropdown";
import {SearchTab} from "../../../search/types/SearchTab";
import {useAppDispatch} from "../../../store/hooks";

interface IProps {
    label?: string;
    name: string;
    onInputClick: (defaultAction: () => void) => void;
    onRegionSelect?: (regionName: string) => void;
}

export const UserPreferencesRegionField = (props: IProps) => {
    const dispatch = useAppDispatch();
    const {setValue, formState} = useFormContext();
    const regions = useWatch({name: props.name});
    const regionsError = formState.errors["regions"]?.message;
    const regionIds = useMemo(() => regions.map((region: IOption<number>) => region.value), [regions]);

    const {data} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});
    const [searchValues, setSearchValues] = useState<ISearchAutocompleteFormValues>({
        search: {label: "", tabType: SearchTab.Regions, regions: formState.defaultValues?.regions} as ISearchInputValue
    });

    useEffect(() => {
        if (data && data.length > 0) {
            setSearchValues({
                ...searchValues,
                search: {...searchValues.search, tabType: SearchTab.Regions, regions: data} as ISearchInputValue
            });
        }
    }, [data]);

    const dispatchFetchAllSearchLists = async (searchInput: string) => {
        const searchContentParams = {
            googlePOIs: false,
            regions: true,
            offers: false,
            vendors: false
        };
        return dispatch(fetchAllSearchLists(searchInput, {searchContent: searchContentParams}));
    };

    return (
        <div>
            {props.label && (
                <Text variant="body_copy_2" mb={0.5}>
                    {props.label}
                </Text>
            )}
            <div className={css({position: "relative"})}>
                <SearchAutocomplete
                    values={searchValues}
                    onChange={(newValues) => {
                        setSearchValues(newValues as ISearchAutocompleteFormValues);
                        const regions =
                            newValues.search &&
                            "regions" in newValues.search &&
                            newValues.search.regions.map((region) => ({value: region.id, label: region.short_name}));
                        setValue(props.name, regions || []);

                        if (props.onRegionSelect && regions && regions.length > 0) {
                            const regionNames = regions.map((r) => r.label).join(", ");
                            props.onRegionSelect(regionNames);
                        }
                    }}
                    onAfterChange={noop}
                    onDropdownStatusChange={noop}
                    onAfterTabSwitch={noop}
                    fetchAllSearchLists={dispatchFetchAllSearchLists}
                    inputIcon={<MapMarkerOutlineIcon size="2.4" />}
                    dropdownIcon={<EditIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />}
                    placeholder="Dodaj..."
                    addedRegionPlaceholder={() => "Dodaj..."}
                    disableExtraMargins
                    regionPillWrapperCss={display("block")}
                    errors={typeof regionsError === "string" ? {search: [regionsError], distance: []} : undefined}
                    renderDropdownList={(props) => {
                        return (
                            <SearchAutocompleteDropdown
                                dropdownIsOpen={props.dropdownIsOpen}
                                search={props.search}
                                selectedTab={props.selectedTab}
                                onLinkClick={props.onLinkClick}
                                requestStateObj={props.requestStateObj}
                                activeItem={props.activeItem}
                                offers={props.offers}
                                places={props.places}
                                regions={props.regions}
                                removeRegionTag={props.removeRegionTag}
                                vendors={props.vendors}
                                getFieldProps={props.getFieldProps}
                                className={dropdownStyle}
                            />
                        );
                    }}
                    dropdownWrapperClassName={dropdownWrapper}
                    showArrowOnMobile
                    onInputClick={props.onInputClick}
                />
            </div>
        </div>
    );
};

const dropdownStyle = css({
    overflow: "hidden auto",

    md: {
        maxHeight: "200px !important"
    }
});

const dropdownWrapper = css({
    minWidth: "100% !important"
});
import React, {useEffect, useMemo, useState} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {css} from "@panda/css";

import {display} from "@pg-design/helpers-css";
import {EditIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";
import {noop} from "@pg-mono/nodash";

import {useGetRegionDetailListQuery} from "../../../region/api/get_region_detail_list";
import {fetchAllSearchLists} from "../../../search/actions/fetch_search_all_action";
import {ISearchInputValue} from "../../../search/components/ISearchInputValue";
import {ISearchAutocompleteFormValues, SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {SearchAutocompleteDropdown} from "../../../search/components/search_autocomplete/SearchAutocompleteDropdown";
import {SearchTab} from "../../../search/types/SearchTab";
import {useAppDispatch} from "../../../store/hooks";

interface IProps {
    label?: string;
    name: string;
    onInputClick: (defaultAction: () => void) => void;
    onRegionSelect?: (regionName: string) => void;
}

export const UserPreferencesRegionField = (props: IProps) => {
    const dispatch = useAppDispatch();
    const {setValue, formState} = useFormContext();
    const regions = useWatch({name: props.name});
    const regionsError = formState.errors["regions"]?.message;
    const regionIds = useMemo(() => regions.map((region: IOption<number>) => region.value), [regions]);

    const {data} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});
    const [searchValues, setSearchValues] = useState<ISearchAutocompleteFormValues>({
        search: {label: "", tabType: SearchTab.Regions, regions: formState.defaultValues?.regions} as ISearchInputValue
    });

    useEffect(() => {
        if (data && data.length > 0) {
            setSearchValues({
                ...searchValues,
                search: {...searchValues.search, tabType: SearchTab.Regions, regions: data} as ISearchInputValue
            });
        }
    }, [data]);

    const dispatchFetchAllSearchLists = async (searchInput: string) => {
        const searchContentParams = {
            googlePOIs: false,
            regions: true,
            offers: false,
            vendors: false
        };
        return dispatch(fetchAllSearchLists(searchInput, {searchContent: searchContentParams}));
    };

    return (
        <div>
            {props.label && (
                <Text variant="body_copy_2" mb={0.5}>
                    {props.label}
                </Text>
            )}
            <div className={css({position: "relative"})}>
                <SearchAutocomplete
                    values={searchValues}
                    onChange={(newValues) => {
                        setSearchValues(newValues as ISearchAutocompleteFormValues);
                        const regions =
                            newValues.search &&
                            "regions" in newValues.search &&
                            newValues.search.regions.map((region) => ({value: region.id, label: region.short_name}));
                        setValue(props.name, regions || []);

                        if (props.onRegionSelect && regions && regions.length > 0) {
                            const regionNames = regions.map((r) => r.label).join(", ");
                            props.onRegionSelect(regionNames);
                        }
                    }}
                    onAfterChange={noop}
                    onDropdownStatusChange={noop}
                    onAfterTabSwitch={noop}
                    fetchAllSearchLists={dispatchFetchAllSearchLists}
                    inputIcon={<MapMarkerOutlineIcon size="2.4" />}
                    dropdownIcon={<EditIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />}
                    placeholder="Dodaj..."
                    addedRegionPlaceholder={() => "Dodaj..."}
                    disableExtraMargins
                    regionPillWrapperCss={display("block")}
                    errors={typeof regionsError === "string" ? {search: [regionsError], distance: []} : undefined}
                    renderDropdownList={(props) => {
                        return (
                            <SearchAutocompleteDropdown
                                dropdownIsOpen={props.dropdownIsOpen}
                                search={props.search}
                                selectedTab={props.selectedTab}
                                onLinkClick={props.onLinkClick}
                                requestStateObj={props.requestStateObj}
                                activeItem={props.activeItem}
                                offers={props.offers}
                                places={props.places}
                                regions={props.regions}
                                removeRegionTag={props.removeRegionTag}
                                vendors={props.vendors}
                                getFieldProps={props.getFieldProps}
                                className={dropdownStyle}
                            />
                        );
                    }}
                    dropdownWrapperClassName={dropdownWrapper}
                    showArrowOnMobile
                    onInputClick={props.onInputClick}
                />
            </div>
        </div>
    );
};

const dropdownStyle = css({
    overflow: "hidden auto",

    md: {
        maxHeight: "200px !important"
    }
});

const dropdownWrapper = css({
    minWidth: "100% !important"
});
